const printPage = () => {
    window.print()
}

export default printPage